import { Action } from '../../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../../helpers';
import {
  transformNavigationProjectFeed,
  transformNavigationProjectFeedWS,
} from './project-feed.transformers';

export function navigationProjectFeedReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationProjectFeed') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationProjectFeed'>(
          state,
          transformObjects(result, transformNavigationProjectFeed),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    case 'WS_MESSAGE':
      if (
        action.payload.type === 'contest' ||
        action.payload.type === 'failingProject' ||
        action.payload.type === 'project' ||
        action.payload.type === 'xpContest' ||
        action.payload.type === 'localJobPosted'
      ) {
        return mergeEntities<'navigationProjectFeed'>(
          state,
          transformObjects([action.payload], transformNavigationProjectFeedWS),
          { path: ['navigationProjectFeed', action.payload.toUserId] },
        );
      }
      return state;
    default:
      return state;
  }
}

export function navigationProjectFeedFailingProjectsReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationProjectFeedFailingProjects') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationProjectFeedFailingProjects'>(
          state,
          transformObjects(result, transformNavigationProjectFeed),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function navigationProjectFeedFailingContestsReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationProjectFeedFailingContests') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationProjectFeedFailingContests'>(
          state,
          transformObjects(result, transformNavigationProjectFeed),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/datastore/navigation/project-feed/project-feed.reducer.ts